import React, { useEffect, useRef, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from '@/ui/Button/Button';
import { Flex } from '@/ui/Flex/Flex';
import { Input } from '@/ui/Input/Input';
import { Modal } from '@/ui/Modal/Modal';
import { TOASTTYPE, useToast } from '@/ui/Toast/Toast';

import { useUserInfo, UserInfo } from '@/features/_data/useUserInfo';
import { FrontendSlide } from '@/types/SlideType';

export const EnterUrlModal = ({
  onUpdateSlide,
  setReplaceWebslide,
  slide,
}: {
  readonly slide: FrontendSlide | null;
  readonly setReplaceWebslide: React.Dispatch<React.SetStateAction<boolean>>;
  readonly onUpdateSlide: (
    slideId: string | null,
    slideData: FrontendSlide | null,
  ) => void;
}) => {
  const intl = useIntl();
  const toast = useToast();
  const { data: userData } = useUserInfo();

  const [url, setUrl] = useState(slide?.asset ?? '');

  const inputElementRef = useRef<HTMLInputElement | null>(null);

  useEffect(() => {
    if (inputElementRef.current) {
      inputElementRef.current.focus();
      inputElementRef.current.select();
    }
  }, []);

  const handleModalClose = () => {
    setReplaceWebslide(false);
  };

  return (
    <form
      onSubmit={(event) => {
        event.preventDefault();

        if (
          !url.match(
            /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([\/\w .-]*)*\??(?:&?[^=&]*=[^=&]*)*/,
          )
        ) {
          toast({
            title: intl.formatMessage({
              defaultMessage: 'The entered URL is not in a valid format.',
              id: 'CgcKfY',
            }),
            subtitle: intl.formatMessage({
              defaultMessage: 'Please check for correctness of the URL.',
              id: 'YnV9o4',
            }),
            mode: TOASTTYPE.Warn,
          });
          return;
        }

        onUpdateSlide(slide?.slideId ?? null, {
          ...slide,
          customer: (userData as UserInfo).customer,
          contentType: 'text/html',
          asset: url,
          index: slide?.index ?? 100000,
          name: url,
        } as FrontendSlide);

        handleModalClose();
      }}
    >
      <Modal
        footer={
          <Flex gap={16} grow justify="flex-end" padding={32}>
            <Button mode="link" onClick={handleModalClose} size="large">
              <FormattedMessage defaultMessage="Cancel" id="47FYwb" />
            </Button>
            <Button size="large" type="submit">
              <FormattedMessage defaultMessage="Save" id="jvo0vs" />
            </Button>
          </Flex>
        }
        onClose={handleModalClose}
        title={<FormattedMessage defaultMessage="Add Webslide" id="HMnbtG" />}
      >
        <Input
          onChange={setUrl}
          placeholder={intl.formatMessage({
            defaultMessage: 'URL',
            id: 'bWjdfa',
          })}
          ref={inputElementRef}
          value={url}
        />
      </Modal>
    </form>
  );
};
